<div class="permission-wrapper">
  <div class="heading-wrapper">
    <h2>{{ 'myAccount.permissions.title' | cxTranslate }}</h2>
    <span> {{ 'myAccount.permissions.details' | cxTranslate }} </span>
  </div>
  <ng-container *ngIf="permissionList$ | async as data; else showSpinner">
    <div class="myaccount-permission-wrapper">
      <ng-container *ngFor="let enum of data.enums">
        <mat-checkbox
          #permissionCheckbox
          class="permission-checkbox"
          [disabled]="checkValue(enum)"
          [checked]="compareValue(enum, this.permissionCodes, permissionCheckbox)"
          [value]="enum"
          disableRipple
          (change)="onChangeEventFunc(enum.code, $event)"
        >
          {{ enum.name }}
          <span [innerHtml]="getTranslation(enum.code) | async"></span>
        </mat-checkbox>
      </ng-container>
    </div>
  </ng-container>
  <ng-template #showSpinner>
    <div class="spinner-container">
      <mat-spinner [diameter]="72"></mat-spinner>
    </div>
  </ng-template>
</div>
